/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularCropperjsModule } from 'angular-cropperjs';
import { TranslocoModule } from '@jsverse/transloco';
import { ImageCropperComponent } from './image-cropper.component';
import { AeroModule } from '../../aero/aero.module';

@NgModule({
  declarations: [ImageCropperComponent],
  imports: [
    AngularCropperjsModule,
    CommonModule,
    AeroModule,
    TranslocoModule,
  ],
  exports: [
    ImageCropperComponent,
  ],
})
export class BulbImageCropperModule { }
